'use strict';

angular.module('app.helpers', [])
// directive implements select2 
// Usage
/*
 * <t3bs-select2 class="form-control"
 *  select2-value="id"
 *  select2-display="name"
 *  select2-model="employee.contract_type"
 *  source="contractTypes">
 * </t3bs-select2>
 */
.directive('t3bsSelect2', function ($timeout) {
  return {
    restrict: 'E',
    scope: {
      select2Model: '=',
      select2Callback: '=',
      source: '='
    },
    transclude: true,
    template: '<select class="t3bsSelect2" style="width: 100%">' + '<option ng-repeat="c in source" value="{{ c[idv] }}">{{ c[valuev] }}</option>' + '</select>',
    replace: true,
    link: function link(scope, element, attrs) {
      scope.idv = attrs.select2Value || 'id';
      scope.valuev = attrs.select2Display || 'name';

      //init
      $timeout(function () {
        $(element).select2({ theme: 'bootstrap' });
        element.select2Initialized = true;
        //watchers
        scope.$watch('source', reload);
        scope.$watch('select2Model', updateSelection);
      });

      function reload() {
        if (!element.select2Initialized) return;
        $timeout(function () {
          $(element).trigger('change');
          updateSelection();
        });
      };

      function updateSelection() {
        if (!scope.select2Model) {
          checkModel();
          return;
        }

        if (element.idOpt == scope.select2Model[scope.idv]) return;

        $(element).val(scope.select2Model[scope.idv]).trigger("change");
      }

      //events listener of select
      $(element).on("select2:select", changeModel);
      function changeModel(e, id) {
        element.idOpt = e.params.data[scope.idv] || e.params.data['id'];
        $timeout(function () {
          scope.select2Model = search(element.idOpt, scope.source);
          if (scope.select2Callback) {
            scope.select2Callback(scope.select2Model);
          }
        });
      };

      //helpers
      function search(indx, list) {
        for (var i = 0; i < list.length; i++) {
          if (list[i][scope.idv] == indx) {
            return list[i];
          }
        }
      };

      function checkModel() {
        if (!scope.source) return;
        if (scope.source.length) {
          if (!scope.select2Model) {
            scope.select2Model = scope.source[0];
          }
        }
      };
    }
  };
});
'use strict';

angular.module('app.helpers').directive('t3bDropzone', function () {
  return {
    template: function template(tElt, tAttrs) {
      return ' <div class="uploader-inline" id="dropzone"> \
                <input type="file" multiple="true" name="file" style="display:none"> \
                <ul class="list-files" ng-show="filesModel.length"> \
                  <li class="filePrev" ng-repeat="file in filesModel" > \
                    <div class="head-file"> \
                      <img ng-src="{{ getImage(file) }}" class="filePrev" alt=""> \
                      <small class="size"><strong>{{ calcSize(file.size) }}</strong></small> \
                    </div> \
                    <div class="footer-file"> \
                      <button ng-click="$event.preventDefault(); $event.stopPropagation(); deleteFile(file, $index)" \
                        class="btn btn-flat btn-xs btn-danger flat-btn"> \
                        <i class="fa fa-times"></i> \
                      </button> \
                    </div> \
                    <small class="truncate namefile" ng-if="file.name">{{ file.name }}</small> \
                    <small class="truncate namefile" ng-if="!file.name"> \
                      <a href="javascript:void(0);"  \
                        google-view="file" \
                        google-view-type="document" \
                        class="mailbox-attachment-name"> \
                      <i class="fa fa-paperclip"></i>  \
                      {{ getName(file.file_url)  }} \
                      </a> \
                    </small> \
                  </li> \
                </ul> \
                <div class="uploader-inline-content" ng-show="!filesModel.length"> \
                  <div class="upload-ui"> \
                    <h2 class="instructions">Arrastre ficheros a cualquier lugar para cargarlos</h2> \
                    <p class="instructions">o</p> \
                    <button class="btn btn-flat bg-purple"> \
                      <i class="fa fa-upload"></i>  \
                      Seleccionar archivos \
                    </button> \
                  </div> \
                  <div class="rules"> \
                    <p>Tamaño máximo del fichero: 20 MB.</p> \
                  </div> \
                </div> \
              </div>';
    },
    scope: {
      filesModel: '='
    },
    link: function link(scope, element, attrs) {
      var $input = element[0].querySelector('input');
      var $dropzone = element[0].querySelector('#dropzone');

      function triggerCallback(e) {
        console.log(e);
        var files;
        if (e.dataTransfer) {
          files = e.dataTransfer.files;
        } else if (e.target) {
          files = e.target.files;
        }
        for (var i = 0; i < files.length; i++) {
          scope.filesModel.push(files.item(i));
          scope.$apply();
        }
        console.log(scope.filesModel);
      };

      scope.deleteFile = function (file, ind) {
        scope.filesModel.splice(ind, 1);
        console.log(file, ind);
      };

      scope.calcSize = function (bytes) {
        if (bytes == undefined) return '';
        if (bytes == 0) return '0 Byte';
        var k = 1000; // or 1024 for binary
        var dm = 2;
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
      };

      scope.getName = function (url) {
        return url.split('/').pop();
      };

      scope.getImage = function (file) {
        var url = file.name || file.file_url;
        var ext = getExtension(url);
        switch (ext) {
          case 'xls':
          case 'xlsx':
            return 'http://i64.tinypic.com/f4mxi8.jpg';
          case 'doc':
          case 'docx':
            return 'http://i64.tinypic.com/106h3x4.jpg';
          case 'pdf':
            return 'http://i67.tinypic.com/aviv6t.jpg';
          case 'jpeg':
          case 'jpg':
          case 'png':
          case 'gif':
            return 'http://i66.tinypic.com/2d6sbnt.jpg';
          default:
            return 'http://i66.tinypic.com/2anwpw.jpg';
        }
      };

      function getExtension(filename) {
        return filename.split('.').pop();
      };

      $input.addEventListener('change', triggerCallback);

      var show = false;
      $dropzone.addEventListener('dragover', function (e) {
        e.preventDefault();e.stopPropagation();

        show = true;
        $dropzone.classList.add('dragover');
      });
      $dropzone.addEventListener('dragleave', function (e) {
        e.preventDefault();e.stopPropagation();

        show = false;
        setTimeout(function () {
          if (!show) {
            $dropzone.classList.remove('dragover');
          }
        }, 200);
      });
      $dropzone.addEventListener('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $dropzone.classList.remove('dragover');
        triggerCallback(e);
      });

      $dropzone.addEventListener('click', function () {
        $input.value = null;
        $input.click();
      });
    }
  };
});
'use strict';

angular.module('app.users', []).service('UsersService', ['$http', 'CONFIG', function ($http, CONFIG) {
  this.url = CONFIG.API_URL + 'licencias/';
  this.currentUser = null;

  this.getAll = function (callback) {
    return $http.get(this.url).then(callback);
  };

  this.getSucursal = function (id, callback) {
    return $http.get(this.url + id + '/sucursales').then(callback);
  };

  this.get_delete_driver = function (id, callback) {
    return $http.get(this.url + 'anulada/' + id).then(callback);
  };

  this.get_one_driver = function (id, callback) {
    return $http.get(this.url + id).then(callback);
  };

  this.setCurrentUser = function (user) {
    this.currentUser = user;
  };
  this.edit = function (data, callback, error) {
    var conf = {
      url: this.url + 'editar/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };

    return $http(conf).then(callback, error);
  };

  this.update = function (data, callback, error) {
    var conf = {
      url: this.url + 'actualizar/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };

    return $http(conf).then(callback, error);
  };

  this.create_driver = function (data, callback, error) {

    var conf = {
      url: this.url + 'crear-conductor/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };
    return $http(conf).then(callback, error);
  };
}]);
'use strict';

angular.module('app.users').controller('UsersCtrl', ['$scope', 'Notification', 'CONFIG', 'UsersService', '$location', function ($scope, Notification, CONFIG, UsersService, $location) {
  $scope.baseUrl = CONFIG.PUBLIC_URL;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;

  $scope.users = [];

  UsersService.getAll(function (response) {
    $scope.drivers = response.data;
    console.log($scope.drivers);
  });

  $scope.search = function () {

    // Write on keyup event of keyword input element
    $("#search").keyup(function () {

      var valu = this;
      // Show only matching TR, hide rest of them
      $.each($("#userTable tbody tr"), function () {
        if ($(this).text().toLowerCase().indexOf($(valu).val().toLowerCase()) === -1) $(this).hide();else $(this).show();
      });
    });
  };
  $scope.new_conduct = function () {
    $location.path('/new/');
  };
  $scope.edit_conduct = function (id) {
    $location.path('/edit/' + id);
  };
  $scope.renove_conduct = function (id) {
    $location.path('/renove/' + id);
  };

  $scope.detail_conduct = function (id) {
    console.log(id);
    $location.path('/detail/' + id);
  };
  $scope.openImage = function (imagen) {
    console.log('entro');
    $scope.imageFull = imagen;
    $('#imageFull').modal('show');
  };
  $scope.delete_conduct = function (id) {
    var r = confirm("Una vez anulado no podrá modificar  esto. ¿Estas seguro que desea anular este documento?");

    if (r != true) {

      return;
    };

    console.log('entro');
    UsersService.get_delete_driver(id, function (response) {

      $location.path('/licencias');
    });
  };
}]);
'use strict';

angular.module('app.users').controller('RenoveCtrl', ['$scope', 'CONFIG', 'UsersService', '$routeParams', '$location', 'Notification', function ($scope, CONFIG, UsersService, $routeParams, $location, Notification) {

  $scope.baseUrl = CONFIG.PUBLIC_URL;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;
  $scope.button_renove = false;

  var id_entidad = $scope.$parent.user.user.id_entidad;

  UsersService.get_one_driver($routeParams.id, function (response) {
    $scope.driver_server = response.data[0];
    console.log($scope.driver_server.fecha_expedicion);
  });

  UsersService.getSucursal(id_entidad, function (response) {
    $scope.sucursales = response.data;
    console.log($scope.sucursales);
  });

  console.warn($routeParams.id);

  //comparar fecha expedición
  $scope.compare_date_expe = function () {

    var expedicion = new Date($scope.driver_server.vigencia);
    var date_expire = expedicion.setDate(expedicion.getDate() + 1);

    date_expire = new Date(date_expire).getTime();

    //console.log(date_expire);
    // date_current = date_current.setDate($scope.driver.fecha_expedicion.getDate() + 1);
    //console.log(date_current);
    var date_current = $scope.driver.fecha_expedicion.getTime();

    if (date_expire >= date_current) {

      console.log('hoalaa');
      $scope.button_renove = false;

      Notification.error('La fecha que intentas ingresar debe  mayor  a la actual');
    } else {

      $scope.button_renove = true;
    };
  };

  //compara fechas vigentes  
  $scope.compare_date_vige = function () {

    var vigencia = new Date($scope.driver_server.vigencia);

    var date_vige = vigencia.setDate(vigencia.getDate());
    date_vige = new Date(date_vige).getTime();

    var date_current = $scope.driver.vigencia.getTime();

    if (date_vige >= date_current) {

      console.log('hoalaa');
      $scope.button_renove = false;

      Notification.error('La fecha que intentas ingresar debe  mayor  a la actual');
    } else {

      $scope.button_renove = true;
    };
  };
  //actualiza  la licencia 
  $scope.update_driver = function (data) {

    data.empresa = id_entidad;
    data.id = $scope.driver_server.id;
    console.log(data);

    console.log(data);
    var fd = new FormData();
    for (var key in data) {
      fd.append(key, data[key]);
    }UsersService.update(fd, function (response) {
      Notification.success('Licencia renovada exitosamente');

      $location.path('/licencias');
    });
  };
  $scope.openImage = function (imagen) {
    console.log('entro');
    $scope.imageFull = imagen;
    $('#imageFull').modal('show');
  };
  $scope.back_licenses = function () {

    $location.path('/licencias');
  };
}]);
'use strict';

angular.module('app.users').controller('NewCtrl', ['$scope', 'CONFIG', '$location', 'Notification', 'UsersService', function ($scope, CONFIG, $location, Notification, UsersService) {
  $scope.baseUrl = CONFIG.PUBLIC_URL;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;

  $scope.continueForm = false;

  var id_entidad = $scope.$parent.user.user.id_entidad;
  console.log('HOla mama!');

  UsersService.getSucursal(id_entidad, function (response) {
    $scope.sucursales = response.data;
    console.log($scope.sucursales);
  });

  $scope.avaliable = function () {

    $scope.continueForm = true;
    console.log($scope.continueForm);
  };
  $scope.save_driver = function (data) {
    data.empresa = id_entidad;

    $scope.continueForm = false;

    console.warn(data);

    var fd = new FormData();

    for (var key in data) {
      fd.append(key, data[key]);
    }UsersService.create_driver(fd, function (response) {

      var res = response.data.error;

      var re = response.data;

      if (!res) {
        $scope.continueForm = true;

        Notification.success('Conductor ' + re + ' guardado correctamente');

        $scope.driver = {};

        angular.element("input[type='file']").val(null);

        $location.path('/licencias');
      } else {

        $scope.continueForm = true;
        Notification.error({ message: res, positionX: 'center' });
      };
    });
  };

  $scope.clear = function () {
    console.log('afsd');

    $scope.driver = {};

    angular.element("input[type='file']").val(null);
  };

  $scope.back_licenses = function () {

    $location.path('/licencias');
  };
}]).directive('fileModel', ['$parse', function ($parse) {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      var model = $parse(attrs.fileModel);
      var modelSetter = model.assign;

      elem.bind('change', function () {
        scope.$apply(function () {
          modelSetter(scope, elem[0].files[0]);
        });
      });
    }
  };
}]).directive('tooltip', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      $(element).hover(function () {
        // on mouseenter
        $(element).tooltip('show');
      }, function () {
        // on mouseleave
        $(element).tooltip('hide');
      });
    }
  };
});
'use strict';

angular.module('app.users').controller('EditCtrl', ['$scope', 'CONFIG', 'UsersService', '$routeParams', '$location', 'Notification', function ($scope, CONFIG, UsersService, $routeParams, $location, Notification) {

  $scope.baseUrl = CONFIG.PUBLIC_URL;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;

  var id_entidad = $scope.$parent.user.user.id_entidad;

  UsersService.get_one_driver($routeParams.id, function (response) {
    $scope.driver = response.data[0];

    //Fecha de expedición
    var expedicion = new Date($scope.driver.fecha_expedicion);
    $scope.driver.fecha_expedicion = expedicion.setDate(expedicion.getDate() + 1);
    $scope.driver.fecha_expedicion = new Date($scope.driver.fecha_expedicion);
    //End fecha expedición

    //Fecha de nacimiento 
    var nacimiento = new Date($scope.driver.fecha_nacimiento);
    $scope.driver.fecha_nacimiento = nacimiento.setDate(nacimiento.getDate() + 1);
    $scope.driver.fecha_nacimiento = new Date($scope.driver.fecha_nacimiento);
    //End fecha de nacimiento

    //Vigencia
    var vigencia = new Date($scope.driver.vigencia);
    $scope.driver.vigencia = vigencia.setDate(vigencia.getDate() + 1);
    $scope.driver.vigencia = new Date($scope.driver.vigencia);
    //End vigencia
  });

  UsersService.getSucursal(id_entidad, function (response) {
    $scope.sucursales = response.data;
    console.log($scope.sucursales);
  });

  $scope.avaliable = function () {

    $scope.continueForm = true;
    console.log($scope.continueForm);
  };

  $scope.edit_driver = function (data) {

    data.empresa = id_entidad;

    console.log(data);
    var fd = new FormData();
    for (var key in data) {
      fd.append(key, data[key]);
    }UsersService.edit(fd, function (response) {
      Notification.success('Modificado correctamente');
      $location.path('/licencias');
    });
  };

  $scope.clear = function () {
    console.log('afsd');

    $scope.driver = {};

    angular.element("input[type='file']").val(null);
  };
  $scope.back_licenses = function () {

    $location.path('/licencias');
  };
}]);
'use strict';

angular.module('app.users').controller('DetailCtrl', ['$scope', 'CONFIG', 'UsersService', '$routeParams', function ($scope, CONFIG, UsersService, $routeParams) {

  $scope.baseUrl = CONFIG.PUBLIC_URL;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;

  var id_entidad = $scope.$parent.user.user.id_entidad;

  console.warn($routeParams.id);
  UsersService.get_one_driver($routeParams.id, function (response) {
    $scope.driver = response.data[0];
  });

  $scope.openImage = function (imagen) {
    console.log('entro');
    $scope.imageFull = imagen;
    $('#imageFull').modal('show');
  };
  $scope.back_licenses = function () {

    $location.path('/licencias');
  };
}]);
'use strict';

angular.module('app.statistics', []).service('GraficsService', ['$http', 'CONFIG', function ($http, CONFIG) {
    this.url = CONFIG.API_URL + 'statistics/';

    this.getAll = function (id, callback) {
        return $http.get(this.url + id).then(callback);
    };
}]);
'use strict';

angular.module('app.statistics').controller('GraficCtrl', ['$scope', 'GraficsService', 'CONFIG', '$routeParams', function ($scope, GraficsService, CONFIG, $routeParams) {

  $scope.baseUrl = CONFIG.PUBLIC_URL;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;
  var idEntidad = $scope.$parent.user.user.id_entidad;

  GraficsService.getAll(idEntidad, function (response) {
    $scope.grafics = response.data;
    console.log($scope.grafics);

    var documentos_vencidos = $scope.grafics[0].documentos_vencidos;
    var documentos_no_vencidos = $scope.grafics[0].documentos_noVencidos;
    var documentos_null = $scope.grafics[0].documentos_null;
    donut_documents_plate(documentos_vencidos, documentos_null, documentos_no_vencidos);

    var licenses_vencidos = $scope.grafics[0].licencias_vencidas;
    var licenses_no_vencidos = $scope.grafics[0].licencias_habilitadas;
    var licenses_nulos = $scope.grafics[0].licencias_anuladas;

    donut_documents_licenses(licenses_vencidos, licenses_no_vencidos, licenses_nulos);
  });

  //torta documentos placas

  //let total_documentosP =  $scope.grafics[0].documentos_habilitados;

  //let documentos_vencidos =  $scope.grafics[0].documentos_vencidos;
  //
  //
  //
  function donut_documents_plate(vencidos, nulos, no_vencidos) {
    console.log(vencidos);
    console.log(nulos);
    console.log(no_vencidos);
    var donutData = [{ label: "Vencidos", data: vencidos, color: "#AF2525" }, { label: "Nulos", data: nulos, color: "#0073b7" }, { label: "No vencidos", data: no_vencidos, color: "#00a65a" }];
    $.plot("#donut-chart", donutData, {
      series: {
        pie: {
          show: true,
          radius: 1,
          innerRadius: 0.5,
          label: {
            show: true,
            radius: 2 / 3,
            formatter: labelFormatter,
            threshold: 0.1
          }

        }
      },
      legend: {
        show: false
      }
    });
  }

  function donut_documents_licenses(vencidas, no_vencidas, nulas) {
    var donutData = [{ label: "Vencidas", data: vencidas, color: "#AF2525" }, { label: "No vencidas", data: no_vencidas, color: "#00a65a" }, { label: "Nulas", data: nulas, color: "#1D6590" }];
    $.plot("#donut-chart-licenses", donutData, {
      series: {
        pie: {
          show: true,
          radius: 1,
          innerRadius: 0.5,
          label: {
            show: true,
            radius: 2 / 3,
            formatter: labelFormatter,
            threshold: 0.1
          }

        }
      },
      legend: {
        show: false
      }
    });
  }

  function labelFormatter(label, series) {
    return '<div style="font-size:13px; text-align:center; padding:2px; color: #fff; font-weight: 600;">' + label + "<br>" + Math.round(series.percent) + "%</div>";
  }
}]);
'use strict';

angular.module('app.home', []).service('HomeService', ['$http', 'CONFIG', function ($http, CONFIG) {
  var url = CONFIG.API_URL;

  this.handleError = function (res) {
    console.warn(res);
  };

  this.sendRegisterPlate = function (data, callback) {
    var conf = {
      url: url + 'register-plate/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };
    return $http(conf).then(callback);
  };
  this.getAll = function (id, callback, error, noblock) {

    return $http.get(url + 'license-plate/' + id).then(callback, error);
  };
  this.getAllNotifications = function (id, callback, error, noblock) {

    return $http.get(url + 'notification/' + id).then(callback, error);
  };

  this.getAllPlateAvaliable = function (id, callback, error, noblock) {

    return $http.get(url + 'list-plates-avaliable/' + id).then(callback, error);
  };

  this.checkExpire = function (plateDocu, callback, error) {
    return $http.post(url + 'check-document/', plateDocu).then(callback, error);
  };

  this.getAllDocuments = function (id, callback) {
    return $http.get(url + 'documentos/' + id).then(callback);
  };

  this.update = function (data, callback) {
    console.warn(data);
    var conf = {
      url: url + 'document-update/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };
    return $http(conf).then(callback);
  };

  this.editDocument = function (data, success, error) {
    console.warn(data);
    var conf = {
      url: url + 'document-edit/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };
    return $http(conf).then(success, error);
  };
  this.nullDocument = function (data, success, error) {
    console.warn(data);
    var conf = {
      url: url + 'document-null/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };
    return $http(conf).then(success, error);
  };
}]);
'use strict';

angular.module('app.home').controller('HomeCtrl', ['$scope', 'HomeService', 'CONFIG', 'Notification', '$sce', '$interval', 'DTOptionsBuilder', 'DTColumnBuilder', function ($scope, HomeService, CONFIG, Notification, $sce, $interval, DTOptionsBuilder, DTColumnBuilder) {

  $scope.baseUrl = CONFIG.PUBLIC_URL;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;
  $scope.logo = null;
  $scope.plates = {};
  $scope.plate = {};
  $scope.image = [];
  $scope.edit = false;
  $scope.continueForm = false;
  $scope.button_renove = false;
  var fecha_docu_vencido = "";

  $scope.dtOptions = DTOptionsBuilder.newOptions().withDisplayLength(10).withLanguage({
    "sSearch": "Buscar",
    "sLengthMenu": "Mostrar _MENU_ entradas",
    "sEmptyTable": "No hay  documentos que mostrar",
    "sInfo": "Mostrando _START_ a  _END_ de  _TOTAL_ entradas",
    "sZeroRecords": "No se encontraron resultados",
    "oPaginate": {
      "sNext": "Siguiente",
      "sPrevious": "Anterior"
    }
  }).withOption('responsive', true);

  $scope.user = $scope.$parent.user.user;

  var idEntidad = $scope.$parent.user.user.id_entidad;
  /*$('#userTable').DataTable( {
        language: {
                  search: "Buscar"
                      }
  } );*/

  HomeService.getAllNotifications(idEntidad, function (response) {
    $scope.notifications = response.data;
    $scope.counter = $scope.notifications.length;
  });

  HomeService.getAll(idEntidad, function (response) {
    console.log(response);
    $scope.plates = response.data;
  });

  // abre el modal de registro 
  $scope.openForm = function () {
    //$scope.continueForm = false; 


    HomeService.getAllPlateAvaliable(idEntidad, function (response) {

      $scope.platesAvaliable = response.data;
      $('#registerFormModal').modal('show');
    });
  };

  $scope.recoverPassword = function () {

    $('#recoverFormModal').modal('show');
  };
  //trae placa y documento
  $scope.docuPlate = function () {

    console.log('hola');
    console.log($scope.plate.idm_movil);
    console.log($scope.plate.tipoDocumento);

    if ($scope.plate.idm_movil == undefined || $scope.plate.tipoDocument == undefined) {
      return;
    };

    var docuPlateCheck = { "idm_movil": $scope.plate.idm_movil, "tipo_document": $scope.plate.tipoDocument };

    console.log(docuPlateCheck);

    HomeService.checkExpire(docuPlateCheck, function (response) {

      var res = response.data.error;

      var re = response.data;
      console.warn(docuPlateCheck);
      if (!$.trim(re)) {
        $scope.continueForm = true;
        return;
      } else {

        $scope.continueForm = false;
        Notification.error({ message: res, positionX: 'center' });
      };
    });
  };
  //
  //registra el documento la placa
  $scope.saveRegister = function (data) {

    /* let r = confirm("Estas seguro que quiere registrar esta placa  con  "+data.fecha_vence+ "?");
        if(r != true){
         return; 
        };*/

    $scope.continueForm = false;
    data.empresa = idEntidad;

    console.log(data);
    var fd = new FormData();
    for (var key in data) {
      fd.append(key, data[key]);
    }HomeService.sendRegisterPlate(fd, function (response) {

      Notification.success('Registrado correctamente');

      $scope.plate = {};
      angular.element("input[type='file']").val(null);

      $scope.continueForm = false;
    });
  };

  //trae formulario de renovacion
  $scope.openFormRenove = function (documentRenove, documentoTipo) {
    $scope.documentoTipo = documentoTipo;
    $scope.fecha_vencimiento = documentRenove.fecha_vence;

    $scope.documento = angular.copy(documentRenove);

    $scope.documento.entidad = "";

    $scope.documento.no_doc = "";
    console.log($scope.documento);

    $scope.button_renove = false;

    var date_add = new Date(documentRenove.fecha_vence);
    $scope.documento.fecha_vencido = new Date(date_add.setDate(date_add.getDate() + 1));
    $scope.documento.fecha_vence_copy = angular.copy($scope.documento.fecha_vencido);

    fecha_docu_vencido = $scope.documento.fecha_vence;

    $('#renoveFormModal').modal('show');
  };

  //compara la fecha actual con la nueva
  $scope.compareDate = function () {

    var fecha = $scope.documento.fecha_vence_copy;

    var fechaActual = new Date(fecha).getTime();
    var fechaNueva = new Date($scope.documento.fecha_vencido).getTime();

    console.log(fechaActual + ',' + fechaNueva);

    if (fechaActual >= fechaNueva) {

      $scope.button_renove = false;
      Notification.error('La fecha que intentas ingresar debe  mayor  a la actual');
    } else {

      $scope.button_renove = true;
    };
  };

  //trae documentos de la placa
  $scope.openFormDocument = function ($index, placa) {
    $scope.placa_documento = placa;

    HomeService.getAllDocuments($index, function (response) {
      $scope.documents = response.data;

      console.log(placa);

      $('#documentFormModal').modal('show');
    });
  };

  //muestra imagen del documento
  $scope.openImage = function (imagen) {
    console.log('entro');
    $scope.imageFull = imagen;
    $('#imageFull').modal('show');
  };

  $scope.editing = function (id) {

    $scope.edit = true;
    $scope.cod = id;
  };

  $scope.cancel = function () {

    $scope.edit = false;
    $scope.cod = "p";
  };

  //actualiza documento
  $scope.update = function (data) {

    if (data.fecha_vencido != undefined) {
      var date_modify = data.fecha_vencido;
      var date = new Date(date_modify.setDate(date_modify.getDate() - 1));
      $scope.documento.fecha_vence = new Date(date_modify.setDate(date_modify.getDate() + 1));
      data.fecha_vence = date;
    }

    console.warn(data);

    $scope.edit = false;
    $scope.cod = "p";

    $scope.button_renove = false;

    var fd = new FormData();

    for (var key in data) {
      fd.append(key, data[key]);
    }HomeService.update(fd, function (response) {
      console.log(response);
      $scope.documents = response.data;

      Notification.success('Actualizado  correctamente');

      $('#renoveFormModal').modal('hide');

      HomeService.getAllNotifications(idEntidad, function (response) {
        $scope.notifications = response.data;
        console.log($scope.notifications.length);
        $scope.counter = $scope.notifications.length;
      });
    });
  };

  $scope.editDoc = function (data) {

    if (data.fecha_vencido != undefined) {
      var date_modify = data.fecha_vencido;
      var date = new Date(date_modify.setDate(date_modify.getDate() - 1));
      //     $scope.documento.fecha_vence =  new Date(date_modify.setDate(date_modify.getDate()+ 1 ));
      data.fecha_vence = date;
    }

    console.warn(data);

    $scope.edit = false;
    $scope.cod = "p";

    var fd = new FormData();

    for (var key in data) {
      fd.append(key, data[key]);
    }HomeService.editDocument(fd, function (response) {

      $scope.documents = response.data;
      Notification.success('Actualizado  correctamente');

      $('#renoveFormModal').modal('hide');
    });
  };
  $scope.nullDoc = function (data) {

    var r = confirm("Una vez anulado no podrá modificar  esto. ¿Estas seguro que desea anular este documento?");

    if (r != true) {

      return;
    };

    if (data.fecha_vencido != undefined) {
      var date_modify = data.fecha_vencido;
      var date = new Date(date_modify.setDate(date_modify.getDate() - 1));
      //     $scope.documento.fecha_vence =  new Date(date_modify.setDate(date_modify.getDate()+ 1 ));
      data.fecha_vence = date;
    }

    console.warn(data);

    $scope.edit = false;
    $scope.cod = "p";

    var fd = new FormData();

    for (var key in data) {
      fd.append(key, data[key]);
    }HomeService.nullDocument(fd, function (response) {

      $scope.documents = response.data;
      Notification('Anulado  correctamente');

      $('#renoveFormModal').modal('hide');
    });
  };
  $scope.clear = function () {
    $scope.plate = {};

    angular.element("input[type='file']").val(null);
  };
}]).directive('fileModel', ['$parse', function ($parse) {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      var model = $parse(attrs.fileModel);
      var modelSetter = model.assign;

      elem.bind('change', function () {
        scope.$apply(function () {
          modelSetter(scope, elem[0].files[0]);
        });
      });
    }
  };
}]).directive('tooltip', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      $(element).hover(function () {
        // on mouseenter
        $(element).tooltip('show');
      }, function () {
        // on mouseleave
        $(element).tooltip('hide');
      });
    }
  };
});
"use strict";
'use strict';

angular.module('app.home').controller('MainCtrl', ['$scope', '$rootScope', 'AUTH_EVENTS', 'Session', function ($scope, $rootScope, AUTH_EVENTS, Session) {
  console.warn('main ctrl');

  $scope.user = null;
  $scope.expandedMenu = true;

  $scope.setCurrentUser = function (user) {
    $scope.user = user;
  };

  $scope.logout = function (user) {
    $rootScope.$broadcast(AUTH_EVENTS.logout);
  };

  /* responsive menu */
  var screenSizes = $.AdminLTE.options.screenSizes;

  var miniSidebarHandler = function miniSidebarHandler() {
    //Enable hide menu when clicking on the content-wrapper on small screens
    if ($(window).width() <= screenSizes.sm - 1 && $("body").hasClass("sidebar-open")) {
      $("body").removeClass('sidebar-open');
    }
  };

  $(".content-wrapper").click(miniSidebarHandler);

  $scope.toggleMenu = function () {
    console.warn('abrir');
    //Enable sidebar push menu
    if ($(window).width() > screenSizes.sm - 1) {
      if ($("body").hasClass('sidebar-collapse')) {
        $("body").removeClass('sidebar-collapse').trigger('expanded.pushMenu');
      } else {
        $("body").addClass('sidebar-collapse').trigger('collapsed.pushMenu');
      }
    }
    //Handle sidebar push menu for small screens
    else {
        if ($("body").hasClass('sidebar-open')) {
          $("body").removeClass('sidebar-open').removeClass('sidebar-collapse').trigger('collapsed.pushMenu');
        } else {
          $("body").addClass('sidebar-open').trigger('expanded.pushMenu');
        }
      }
  }; //end toggle
  $rootScope.$on('toggleMenu', function () {
    miniSidebarHandler();
  });

  //init
  $scope.setCurrentUser(Session.getUser());
}]);
'use strict';

angular.module('app.home').directive('t3bHeader', function () {
  return {
    scope: {},
    //bindToController: {
    //user: '='
    //},
    controller: ['$rootScope', '$scope', 'Session', function ($rootScope, $scope, Session) {
      var vm = this;

      vm.logout = $rootScope.logout;
      vm.loggedUser = $scope.$parent.user;

      /* responsive menu */
      var screenSizes = $.AdminLTE.options.screenSizes;

      var miniSidebarHandler = function miniSidebarHandler() {
        //Enable hide menu when clicking on the content-wrapper on small screens
        if ($(window).width() <= screenSizes.sm - 1 && $("body").hasClass("sidebar-open")) {
          $("body").removeClass('sidebar-open');
        }
      };

      $(".content-wrapper").click(miniSidebarHandler);

      vm.toggleMenu = function () {
        //Enable sidebar push menu
        if ($(window).width() > screenSizes.sm - 1) {
          if ($("body").hasClass('sidebar-collapse')) {
            $("body").removeClass('sidebar-collapse').trigger('expanded.pushMenu');
          } else {
            $("body").addClass('sidebar-collapse').trigger('collapsed.pushMenu');
          }
        }
        //Handle sidebar push menu for small screens
        else {
            if ($("body").hasClass('sidebar-open')) {
              $("body").removeClass('sidebar-open').removeClass('sidebar-collapse').trigger('collapsed.pushMenu');
            } else {
              $("body").addClass('sidebar-open').trigger('expanded.pushMenu');
            }
          }
      }; //end toggle
      $rootScope.$on('toggleMenu', function () {
        miniSidebarHandler();
      });
    }],
    controllerAs: 'ctrl',
    template: ' \n      <header class="main-header">\n        <!-- Logo -->\n        <a href="/" class="logo">\n          <!-- mini logo for sidebar mini 50x50 pixels -->\n          <span class="logo-mini"><b>TM</b></span>\n          <!-- logo for regular state and mobile devices -->\n         <!-- <span class="logo-lg"><b>Trasmovil</b> S.A.S</span>-->\n          <img src="/assets/img/trasmovil_logo.png" width="120px" class="user-image" alt="User Image">\n        </a>\n        <!-- Header Navbar: style can be found in header.less -->\n        <nav class="navbar navbar-static-top text-center" role="navigation">\n          <!-- Sidebar toggle button-->\n          <a href="javascript:void(0);" ng-click="ctrl.toggleMenu()" class="sidebar-toggle" data-toggle="offcanvas" role="button">\n            <span class="sr-only">Toggle navigation</span>\n            <span class="icon-bar"></span>\n            <span class="icon-bar"></span>\n            <span class="icon-bar"></span>\n          </a>\n          <div class="navbar-custom-menu">\n            <ul class="nav navbar-nav">\n <li class="dropdown messages-menu">\n <a href="#" class="dropdown-toggle" data-toggle="dropdown">\n <i class="fa fa-bell-o fa-2x"></i>\n <span class="label label-danger">1</span>\n </a>\n <ul class="dropdown-menu">\n <li class="header">Tienes 1 documentos vencidos</li>\n <li>\n <!-- inner menu: contains the actual data -->\n <ul class="menu">\n <li><!-- start message -->\n <a href="#">\n <div class="pull-left">\n <img src="http://localhost:8000/image/documento.png" class="img-circle" alt="User Image">\n </div>\n <h4>\n SOAT\n <small><i class="fa fa-clock-o"></i> 5 mins</small>\n </h4>\n <p>Placa: TYT435</p>\n </a>\n </li><!-- end message -->\n ...\n </ul>\n </li>\n <li class="footer"><a href="#">Ver todos los mensajes</a></li>\n </ul>\n </li>\n\n                     <li class="dropdown user user-menu">\n                <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown">\n                  <img src="https://randomuser.me/api/portraits/men/21.jpg" class="user-image" alt="User Image">\n                  <span class="hidden-xs">{{ ctrl.loggedUser.user.nombre  }}</span>\n                </a>\n                <ul class="dropdown-menu">\n                  <!-- User image -->\n                  <li class="user-header">\n                    <img src="https://randomuser.me/api/portraits/men/21.jpg" class="img-circle" alt="User Image">\n                    <p>\n                      {{ ctrl.loggedUser.user.nombre +\' \'+ctrl.loggedUser.user.apellido }}\n                    </p>\n                    <p>\n                      {{ ctrl.loggedUser.user.email }}\n                    </p>\n                  </li>\n                  <!-- Menu Footer-->\n                  <li class="user-footer">\n                    <div class="pull-left">\n                      <a href="/perfil" class="btn btn-default btn-flat"><i class="fa fa-user"></i>  Mi información </a>\n                    </div>\n                    <div class="pull-right">\n                      <button ng-click="$rootScope.logout()" class="btn btn-default btn-flat">\n                        <i class="fa fa-sign-out"></i>Salir \n                      </button>\n                    </div>\n                  </li>\n                </ul>\n              </li>\n            </ul>\n          </div>\n        </nav>\n      </header>\n      '
  };
});
'use strict';

angular.module('app.auth', []).service('Session', [function () {

  this.token = null;
  this.user = null;

  //create session from local storage
  this._createLc = function (token, user) {
    window.localStorage.setItem('token', angular.toJson(token));
    window.localStorage.setItem('user', angular.toJson(user));
  };

  //destroy session from local storage 
  this._destroyLc = function () {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('user');
  };

  //create session from memory 
  this.create = function (token, user) {
    this.token = token;
    this.user = user;
    this._createLc(token, user);
  };

  //destroy session from memory 
  this.destroy = function () {
    this.token = null;
    this.user = null;
    this._destroyLc();
  };

  //get token from memory or localStorage
  this.getToken = function () {
    var token = this.token;
    if (!token) {
      token = angular.fromJson(window.localStorage.getItem('token'));
    }
    return token;
  };

  //get user from memory or localStorage
  this.getUser = function () {
    var user = this.user;
    if (!user) {
      user = angular.fromJson(window.localStorage.getItem('user'));
    }
    return user;
  };

  this.isAuthenticated = function () {
    return this.getToken() != null;
  };
}]);
'use strict';

angular.module('app.auth').factory('AuthInterceptor', ['$rootScope', '$q', 'AUTH_EVENTS', 'Session', function ($rootScope, $q, AUTH_EVENTS, Session) {
  return {
    // poner el token en cada request
    request: function request(config) {
      var token = Session.getToken();
      if (token) {
        config.headers.Authorization = 'Token ' + token;
      }
      return config;
    },
    responseError: function responseError(response) {
      console.log("entro por interceptor de error");
      $rootScope.$broadcast({
        401: AUTH_EVENTS.notAuthenticated,
        403: AUTH_EVENTS.notAuthorized
      }[response.status], response);
      console.log(response);
      return $q.reject(response);
    }
  };
}]);
'use strict';

angular.module('app.auth').service('LoginService', ['$http', 'CONFIG', 'Session', function ($http, CONFIG, Session) {
  var url = CONFIG.API_URL + 'auth/';

  this.handleError = function (res) {
    console.warn(res);
  };

  /*
   *api token request
   */
  this.requestToken = function (data, callback, error) {
    return $http.post(url + 'login', data).then(callback, error);
  };

  /*
   *login, create a session
   */
  this.login = function (token, callback) {
    var config = {
      method: 'GET',
      url: CONFIG.API_URL + 'users/me/',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        'Authorization': 'Bearer ' + token
      }
    };

    return $http(config).then(function (response) {
      Session.create(token, response.data);
      callback(response);
    }, this.handleError);
  };
}]);
'use strict';

angular.module('app.auth').controller('LoginCtrl', ['$scope', 'LoginService', '$location', function ($scope, LoginService, $location) {

  $scope.user = {};
  $scope.busy = false;

  /* handle success login */
  var successLogin = function successLogin(response) {
    //get user data, create a session and redirect to home
    LoginService.login(response.data.token, function (response) {
      console.warn(response);
      $scope.setCurrentUser(response.data);
      $scope.busy = false;
      $location.path('/');
    });
  };

  /* handle errors on login */
  var errorLogin = function errorLogin(response) {
    $scope.busy = false;
    // $scope.errors = response.data.non_field_errors;
    $scope.errors = [response.data.error];
    console.log(response);
  };

  /* fired when the user click to "Entrar" */
  $scope.login = function () {
    console.warn($scope.user);
    $scope.busy = true;
    LoginService.requestToken($scope.user, successLogin, errorLogin);
  };
  $scope.recoverPassword = function () {
    $('#recoverFormModal').modal('show');
  };
}]);
'use strict';

angular.module('app', ['ngRoute', 'templates', 'app.helpers', 'datatables', 'angular-loading-bar', 'ui.bootstrap', 'ui-notification', 'ngSanitize', 'ui.select', 'xeditable', 'app.auth', 'app.home', 'app.users', 'app.statistics']);
'use strict';

angular.module('app').run(['$rootScope', 'AUTH_EVENTS', 'Session', '$location', 'editableOptions', 'editableThemes', function ($rootScope, AUTH_EVENTS, Session, $location, editableOptions, editableThemes) {
  editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs2', 'default'
  editableThemes['bs3'].submitTpl = '<button class="btn btn-flat btn-primary" type="submit">' + '<i class="fa fa-check"></i></button>';

  editableThemes['bs3'].cancelTpl = '<button class="btn btn-flat btn-default" ng-click="$form.$cancel()">' + '<i class="fa fa-times"></i></button>';

  function logout() {
    Session.destroy();
    $location.path('/login');
  }

  $rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {
    logout();
    console.info('se activo interceptor not authenticated');
  });

  $rootScope.$on(AUTH_EVENTS.notAuthorized, function () {
    logout();
    console.info('se activo interceptor not authorized');
  });

  $rootScope.$on(AUTH_EVENTS.logout, function () {
    logout();
    console.info('se cerrara la sesion');
  });

  $rootScope.$on('$routeChangeStart', function (event, next) {
    if ($location.path() !== '/login') {
      if (!Session.isAuthenticated()) {
        logout();
      }
    }
  });
  $rootScope.logout = function () {
    logout();
  };

  $rootScope.goTo = function (url) {
    $location.path(url);
  };
}]);
'use strict';

/*
 * url routes
 */

angular.module('app').config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {
  'use strict';

  $routeProvider.when("/login", {
    controller: "LoginCtrl",
    templateUrl: "app/auth/login.html"
  }).when("/", {
    controller: "GraficCtrl",
    templateUrl: "app/statistics/estatistics.html"
  }).when("/home", {
    controller: "HomeCtrl",
    templateUrl: "app/home/home.html"
  }).when("/licencias", {

    controller: "UsersCtrl",
    templateUrl: "app/users/users.html"
  }).when("/new", {
    controller: "NewCtrl",
    templateUrl: "app/users/users-new.html"
  }).when("/edit/:id", {
    controller: "EditCtrl",
    templateUrl: "app/users/users-edit.html"
  }).when("/renove/:id", {
    controller: "RenoveCtrl",
    templateUrl: "app/users/users-renove.html"
  }).when("/detail/:id", {
    controller: "DetailCtrl",
    templateUrl: "app/users/users-detail.html"
  }).when("/notificaciones", {
    controller: "HomeCtrl",
    templateUrl: "app/notifications/notifications.html"
  }).otherwise({
    redirectTo: '/'
  });
  $locationProvider.html5Mode(true);
}]);
"use strict";

angular.module("app").constant("CONFIG", {
  ROOT_UR: "http://localhost:8080/",
  API_URL: "http://betadesarrollo.cotracol.com/index.php/api/v1/",
  //API_URL: "http://localhost:8000/api/v1/",
  PUBLIC_URL: "http://fdn-static.bimaps.cloud-alls.trasmovil.co",
  PUBLIC_URL_SERVER_LOCAL: "http://localhost:8000"

}).constant("AUTH_EVENTS", {
  notAuthenticated: "auth-not-authenticated",
  notAuthorized: "auth-not-authorized",
  logout: "auth-logout"
});
'use strict';

angular.module('app').config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push(['$injector', function ($injector) {
    return $injector.get('AuthInterceptor');
  }]);
}]).config(['NotificationProvider', function (NotificationProvider) {
  NotificationProvider.setOptions({
    delay: 2000,
    startTop: 60,
    startRight: 10,
    verticalSpacing: 20,
    horizontalSpacing: 20,
    positionX: 'right',
    positionY: 'top'
  });
}]);